import type { DownloadImageDto } from "core/dto";

export const getImageUrl = (imageId: number, dto?: DownloadImageDto) => {
	const config = useRuntimeConfig();

	const queryParams = new URLSearchParams();
	if (dto) {
		Object.entries(dto).forEach(([key, value]) => {
			queryParams.append(key, value);
		});
	}
	const queryString = queryParams.size ? "?" + queryParams : "";

	return `${config.public.baseUrl}/images/${imageId}${queryString}`;
};
